/**
 * Le format de date de l'application : jj/mm/aaaa, toujours.
 *
 * Règle d'Emeni (2026-08-29), après avoir vu « Rendez-vous : 2026-10-01 10:00 » dans un PDF destiné à être
 * imprimé et transmis. La forme brute de la base (aaaa-mm-jj) n'a rien à faire sous les yeux d'un lecteur :
 * elle sert à trier et à comparer, pas à être lue.
 *
 * Découpage de la chaîne plutôt que `new Date(...)` : une date sans heure interprétée comme un instant UTC
 * peut reculer d'un jour selon le fuseau, et un document daté de la veille est pire qu'un format laid.
 */

/** "2026-10-01" -> "01/10/2026". Une valeur inattendue est rendue telle quelle plutôt que perdue. */
export const formatDateFr = (valeur?: string | null): string => {
    const brut = String(valeur || '').trim();
    if (!brut) return '';
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(brut);
    if (!m) return brut;
    return `${m[3]}/${m[2]}/${m[1]}`;
};

/** "2026-10-01T14:30:00" ou "2026-10-01 14:30" -> "01/10/2026 14:30". L'heure est omise si absente. */
export const formatDateHeureFr = (valeur?: string | null): string => {
    const brut = String(valeur || '').trim();
    if (!brut) return '';
    const date = formatDateFr(brut);
    const h = /[T ](\d{2}:\d{2})/.exec(brut);
    return h ? `${date} ${h[1]}` : date;
};
